export function formatCurrency(val) {
  return (val || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatDate(d) {
  if (!d) return '-';
  // Datas no formato "AAAA-MM-DD" são lidas direto, sem passar por Date, para
  // evitar o deslocamento de um dia em fuso negativo (new Date interpreta como UTC).
  if (typeof d === 'string') {
    var m = d.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return m[3] + '/' + m[2] + '/' + m[1];
  }
  var dd = new Date(d);
  return (
    String(dd.getDate()).padStart(2, '0') +
    '/' +
    String(dd.getMonth() + 1).padStart(2, '0') +
    '/' +
    dd.getFullYear()
  );
}
